/*
 * Password strength evaluation for the mobile reset flow.
 * Mirrors the backend policy: ≥ 8 chars, lower + upper + number + special.
 */

export const PASSWORD_RULES = ["length", "lowercase", "uppercase", "number", "special"];

export function evaluatePassword(password = "") {
    const value = String(password || "");

    const checks = {
        length: value.length >= 8,
        lowercase: /[a-z]/.test(value),
        uppercase: /[A-Z]/.test(value),
        number: /[0-9]/.test(value),
        special: /[^A-Za-z0-9]/.test(value),
    };

    const passed = PASSWORD_RULES.filter((rule) => checks[rule]).length;
    const lengthBonus = value.length >= 12 ? 1 : 0;
    const rawScore = Math.min(4, Math.max(0, passed - 1) + lengthBonus);
    const valid = PASSWORD_RULES.every((rule) => checks[rule]);
    const score = valid ? Math.max(3, rawScore) : Math.min(rawScore, 2);

    return {
        checks,
        valid,
        score, // 0..4
        percent: Math.round((score / 4) * 100),
    };
}

export default evaluatePassword;

